import Image from "next/image";
import { IS_MAIN_SITE } from "@/components/shared/sites/sites";

type Props = {
  amount: number;
};

export default function GemCostToast({ amount }: Props) {
  return (
    <div className="w-fill flex h-[34px] animate-[toast-in_0.5s,fade-out_0.5s_ease-in_3s_forwards] items-center justify-center rounded-full bg-crp-blue px-4 py-1.5 text-sm font-bold text-white">
      <div className="flex items-center justify-center gap-1">
        <Image
          className="flex h-3 w-3 items-center"
          src={
            IS_MAIN_SITE
              ? "https://cdn6.imgpog.com/ruby.webp"
              : "https://cdn6.imgpog.com/diamond.webp"
          }
          alt="Gem"
          width={14}
          height={14}
          objectFit="contain"
          unoptimized
        />
        <span className="flex items-center leading-none">{amount}</span>
      </div>
    </div>
  );
}
